import React from 'react';
import clsx from 'clsx';
import { useInputContext } from './Context';

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  {
    /**
     * @usage to show controlled error state when using without InputWrapper
     */
    hasError?: boolean;
  } & React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ hasError, className, value, ...props }, forwardedRef) => {
  const { error, disabled } = useInputContext();
  return (
    <textarea
      className={clsx(
        'w-full rounded-[6px]  border-0 px-[8px] py-2 font-base text-base-m text-base800',
        'relative rounded-[6px] p-[3px] ring-2 ring-inset transition-all focus:ring-inset',
        'resize-none outline-none placeholder:text-base500',
        (props.disabled || disabled) && 'disabled:cursor-not-allowed disabled:text-base500',
        hasError || !!error
          ? 'scrollbar-error bg-destructive50 ring-destructive50 focus-within:ring-destructive300 hover:ring-1 hover:ring-destructive200'
          : 'scrollbar-light bg-base200 ring-base200 focus:ring-base800 hover:border-base300 hover:bg-base50 hover:ring-1',
        className,
      )}
      ref={forwardedRef}
      disabled={props.disabled || disabled}
      value={value}
      {...props}
    />
  );
});

Textarea.displayName = 'Textarea';
